import React from "react"

/**
 * @param {{
 *   variant?: "primary" | "secondary" | "outline" | "danger" | "text",
 *   size?: "sm" | "md" | "lg",
 *   children?: any,
 *   className?: string,
 *   onClick?: (() => void) | undefined,
 *   type?: "button" | "submit" | "reset",
 *   disabled?: boolean,
 *   icon?: any,
 *   title?: string,
 *   [key: string]: any,
 * }} props
 */
export default function Button(props) {
    const {
        variant = "primary",
        size = "md",
        children,
        className = "",
        onClick = undefined,
        type = "button",
        disabled = false,
        icon = null,
        ...rest
    } = props
    function getVariantClasses() {
        switch (variant) {
        case "primary":
            return "btn-primary shadow-sm"
        case "secondary":
            return "btn-secondary shadow-sm"
        case "outline":
            return "btn-outline-secondary shadow-sm"
        case "danger":
            return "btn-danger shadow-sm"
        case "text":
            return "btn-link text-decoration-none"
        default:
            return "btn-primary shadow-sm"
        }
    }

    function getSizeClasses() {
        switch (size) {
        case "sm":
            return "btn-sm"
        case "lg":
            return "btn-lg"
        default:
            return ""
        }
    }

    const customStyles = variant === "primary" || variant === "secondary" ? {
        "--bs-btn-bg": "#0f6170",
        "--bs-btn-border-color": "#0f6170",
        "--bs-btn-hover-bg": "rgba(15, 97, 112, 0.9)",
        "--bs-btn-hover-border-color": "rgba(15, 97, 112, 0.9)",
        "--bs-btn-active-bg": "rgba(15, 97, 112, 0.8)",
        "--bs-btn-active-border-color": "rgba(15, 97, 112, 0.8)",
        "--bs-btn-disabled-bg": "#0f6170",
        "--bs-btn-disabled-border-color": "#0f6170",
    } : {}

    return (
        <button
            type={/** @type {"button"|"submit"|"reset"} */ (type)}
            className={`btn ${getVariantClasses()} ${getSizeClasses()} ${
                icon ? "d-inline-flex align-items-center" : ""
            } ${className}`}
            style={/** @type {any} */ (customStyles)}
            onClick={onClick}
            disabled={disabled}
            {...rest}
        >
            {icon && <span className="me-2">{icon}</span>}
            {children}
        </button>
    )
}
